export function validatePhoneNumber(text: string | undefined) {
  if (!text) {
    return false;
  }
  var re = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  return re.test(String(text));
}
